<svelte:options accessors={true}/>
<script>
    import HRImport from './../../components/HR/HRImport.svelte';
	import JobRoles from './../../components/HR/JobRoles.svelte';
	import Pagination from './../../components/sorting/Pagination.svelte';
    import { onMount } from 'svelte';
    import ReportsService from "../../services/reports.service";
    import EditableCell from "../../components/EditableCell.svelte";
    import AuthService from '../../services/auth.service.js';
    import HRService from '../../services/hr.service.js';
    import Loader from "../../components/Loader.svelte";
    //Sorting and pagination
    import EntriesSelector from './../../components/sorting/EntriesSelector.svelte';
    import Search from './../../components/sorting/Search.svelte';
    import ExportService from '../../services/export.service';

    let page, loading = false, reportData, errorMessage,
        currentStaff = {}, staffToChange = {},
        currentPage = 0, search = "", sortBy = "id",
        order = true, entries = 100, totalElements = 0,
        staffToDelete;

    export let user, params, loadingExport;

    //Catch when a value change
    $: loadData(params, search, entries, currentPage, order, sortBy, entries);

    onMount(() => {
        loadData();
    });

    const headers = [
        {title: "employee #", key: "employee_id", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 100, exportWidth: 20 },
        {title: "req #", key: "req_id", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 100, exportWidth: 14 },
        {title: "department", key: "department", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "departments", width: 100, exportWidth: 15 },
        {title: "job title", key: "job_title", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 230, exportWidth: 35 },
        {title: "job role", key: "job_role", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "jobRoles", width: 300, exportWidth: 30 },
        {title: "hiring manager", key: "hiring_manager", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 150, exportWidth: 25 },
        {title: "location", key: "location", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 100, exportWidth: 20 },
        {title: "backfill / new", key: "backfill", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "backfill", width: 90, exportWidth: 20 },
        {title: "backfill for", key: "backfill_for", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "",width: 200, exportWidth: 30 },
        {title: "recruiting strategy", key: "recruiting_strategy", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "recruitingStrategy", width: 160, exportWidth: 25 },
        {title: "agency name", key: "agency", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 130, exportWidth: 20 },
        {title: "date Agency Engaged /\n Job First Posted", key: "post_date", customClass : "", editable: true, type: "date", format: 7, selectOptionsKey: "", width: 150, exportWidth: 30 },
        {title: "target hire date", key: "target_hire_date", customClass : "", editable: true, type: "date", format: 7, selectOptionsKey: "", width: 150, exportWidth: 25 },
        {title: "actual start date", key: "start_date", customClass : "", editable: true, type: "date", format: 7, selectOptionsKey: "", width: 150, exportWidth: 20 },
        {title: "status", key: "status", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "statuses", width: 100, exportWidth: 20},
        {title: "fill source", key: "source", customClass : "", editable: true, type: "select", format: 7, selectOptionsKey: "sources", width: 130, exportWidth: 20 },
        {title: "applicant count", key: "applicant_count", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 110, exportWidth: 20 },
        {title: "agency fees", key: "agency_fees", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 105, exportWidth: 20 },
        {title: "posting fees", key: "posting_fees", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 100, exportWidth: 20 },
        {title: "notes", key: "notes", customClass : "", editable: true, type: "text", format: 7, selectOptionsKey: "", width: 200, exportWidth: 35 },
        {title: "length of vacancy", key: "length_of_vacancy", customClass : "", editable: false, type: "", format: 7, selectOptionsKey: "", width: 200, exportWidth: 25 },
        {title: "time to fill", key: "time_to_fill", customClass : "", editable: false, type: "", format: 7, selectOptionsKey: "", width: 100, exportWidth: 20 }
    ];

    async function loadData() {
        if (loading) return;
        loading = true;
        reportData = null;
        const url = '/org/' + params.org + '/hr_open_positions/' + currentPage + "/" + sortBy
        + "/" + order + "/" + entries + getSearch();
        let result = null;

        try {
            result = await ReportsService.load(url);
        } catch (e) {
            console.log('Error', e);
        }

        if (result && result.data) reportData = result.data;
        if (reportData && reportData.totalElements) totalElements = reportData.totalElements;
        loading = false;

        setTimeout(() => {
            tablesLoaded(true);
            enableTableSelection();
        }, 1000);
    }

    export const exportToExcel = async () => {
        loadingExport = true;
        try {
            const url = `/org/${params.org}/export/hr_open_positions/0/id/true/1000`;
            const isFacilitator = !AuthService.can('EXPORT_HR_ALL_PORTCOS');
            const fileName = (!isFacilitator)? 'HR-Open-positions':`HR-Open-positions-${jQuery('#dropdownOrganizations').text()}`;
            const openPositionsReport = (await ReportsService.load(url)).data;
            if (!openPositionsReport && !openPositionsReport.totalElements) {
                alert('Nothing to export');
            } else {
                const headersToExport = [...headers];
                
                if (!isFacilitator) {
                    headersToExport.unshift({title: 'company', key: 'company', exportWidth: 24});
                }

                await ExportService.downloadCommonHrReport(
                    headersToExport,
                    openPositionsReport.staff,
                    fileName,
                    'Open Positions',
                    5,
                );
            }
        } catch (e) {
            console.log('Error', e);
        } finally {
            loadingExport = false;
        }
    };

    let onSaveStaff = async function() {
        let response = null;
        try {
            await ReportsService.saveStaff(currentStaff);
            loadData();
            jQuery('#addStaff').modal('hide');
            cleanStaff();
        } catch (e) {
            errorMessage = e.message;
            console.log(errorMessage);
        }
    }

    function getSearch(){
        return (search)? "/" + search : '';
    }

    export const onSearch = function(searchText){
        search = searchText;
    }

    function cleanStaff() {
        currentStaff = {
            id: '',
            organization_id: params.org,
            req_id: '',
            department: reportData.options.departments[0].value,
            job_title: '',
            notes: ''
        };
    }

    export const addRow = function(){
        cleanStaff();
        jQuery('#addStaff').modal('show');
    }

    function editStaff(candidateToEdit){
        currentStaff = JSON.parse(candidateToEdit);
        staffToChange = {... currentStaff };
        jQuery('#addStaff').modal('show');
    }

    async function updateCandidateData(value, id, field){
        if(jQuery('.hr-pasting').length > 0){
            //Avoid save all the string pasted on the selected cell
            return false;
        }

        try {
            await ReportsService.updateCandidateData({value, id, field}, 'staff');
        } catch (e) {
            console.log('Error', e);
        }
    }

    function sort(key){
        //If it's a different column, set asc bt default. If not, set the opposite (asc = desc, desc = asc)
        order = (sortBy == key)? !order : true;
        sortBy = key;
    }

    export function selectEntries(entriesSelected){
        currentPage = 0;
        entries = entriesSelected;
    }

    let openJobRolesModal = function(){
        jQuery('#jobRolesModal').modal('show');
    }

    function openDeleteStaffModal(staffId){
        staffToDelete = staffId;
        jQuery('#deleteStaffConfirmation').modal('show');
    }

    async function deleteStaff(){
        try {
            await ReportsService.deleteStaff(staffToDelete);
            jQuery('#deleteStaffConfirmation').modal('hide');
            loadData();
        } catch (e) {
            console.log('Error', e);
        }
    }

    //Import
    export const openImportModal = function(){
        jQuery('#importModal').modal('show');
    }

    let onImported = async function(){
        jQuery('#importModal').modal('hide');
        await loadData();
    }
</script>

<!-- Add/edit staff-->
<div class="modal fade" id="addStaff" tabindex="-1" role="dialog" aria-labelledby="addStaff" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="addEmployeeLabel">
                    {#if currentStaff.id}
                        Edit Staff
                    {:else}
                        Add Staff
                    {/if}
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <form on:submit|preventDefault={onSaveStaff}>
                <div class="modal-body">
                    {#if AuthService.can('EDIT_STAFF') }
                        <div class="row">
                            <div class="col-md-12">
                                {#if reportData && reportData.options}
                                    <div class="form-group">
                                        <label for="candidate-req_id">*Req #</label>
                                        <input  bind:value={currentStaff.req_id} type="text" class="form-control" name="candidate-req_id" id="candidate-req_id" placeholder="210191">
                                    </div>
                                    <div class="form-group">
                                        <label for="staff-department">*Department</label>
                                        <select bind:value={currentStaff.department}  class="form-control" name="staff-department" id="staff-department">
                                            {#each reportData.options.departments as department}
                                                <option value="{department.value}">{department.option}</option>
                                            {/each}
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="nameInput">*Job Title</label>
                                        <input required bind:value={currentStaff.job_title} type="text" class="form-control" name="staff-job_title" id="staff-job_title" placeholder="Marketing Contractor">
                                    </div>
                                    <div class="form-group">
                                        <label for="candidate-source">*Source</label>
                                        <select bind:value={currentStaff.source}  class="form-control" name="candidate-source" id="candidate-source">
                                            {#each reportData.options.sources as source}
                                                <option value="{source.value}">{source.option}</option>
                                            {/each}
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="staff-notes">Notes</label>
                                        <textarea bind:value={currentStaff.notes} type="text" class="form-control" id="staff-notes" placeholder="Notes" rows="5"></textarea>
                                    </div>
                                {/if}
                            </div>
                        </div>
                    {/if}

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" on:click={cleanStaff}>Close</button>

                    <button type="submit" class="btn btn-success">
                        {#if currentStaff.id}
                            Update
                        {:else}
                            Save
                        {/if}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>

<!-- Delete staff -->
<div class="modal fade" id="deleteStaffConfirmation" tabindex="-1" role="dialog" aria-labelledby="deleteStaffConfirmation" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="deleteStaffLabel">
                    <i class="text-danger fa fa-exclamation-triangle ml-1"></i> WARNING!
                </h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <p>Are you sure you want to delete this position?</p>
            </div>
            <div class="modal-footer text-right">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" >Cancel</button>
                <button type="button" class="btn btn-danger " on:click={() => deleteStaff()} >
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

{#if loading}
    <Loader></Loader>
{:else}
    {#if AuthService.can('IMPORT_HR_REPORTS') }
        <HRImport params={params} module="staff" on:imported={onImported}></HRImport>
    {/if}
    <JobRoles></JobRoles>
    <button class="d-none" id="reloadData" on:click={loadData}>RELOAD</button>
    <div class="table-wrapper hr-report">
        <table class="table table-sm container-fluid table-weekly selectable-table">
            <thead>
                <tr class="bg-dark text-light">
                    <th class="delete-cell"></th>
                    {#each headers as header, headerIndex}
                        {#if header.editable}
                            <th
                              style="min-width: {header.width}px"
                              class="col-subheader {header.customClass} {headerIndex > 4 ? 'notFixed' : '' }">

                                <span class="pointer" on:click={() => sort(header.key)}>
                                    {header.title}
                                    <i class="fa fa-sort-{(sortBy == header.key && !order) ? 'desc' : 'asc' } {(sortBy == header.key) ? 'text-primary' : '' }"></i>
                                </span>
                                {#if header.key == 'job_role'}
                                    <i
                                        class="fa fa-info-circle ml-2 mr-1 vertical-middle pointer"
                                        on:click={ openJobRolesModal }
                                    ></i>
                                {/if}
                            </th>
                        {:else}
                             <th style="min-width: {header.width}px" class="col-subheader {headerIndex > 4 ? 'notFixed' : '' } {header.customClass}">{header.title}</th>
                        {/if}
                    {/each}
                </tr>
            </thead>
            <tbody>
                {#each reportData.staff as staff, staffIndex}
                    <tr>
                        {#if AuthService.can('EDIT_STAFF') }
                            <th class="delete-cell">
                                <i
                                    class="fa fa-trash text-danger pointer"
                                    on:click={() => openDeleteStaffModal (staff.id)}
                                ></i>
                            </th>
                            {#each headers as header, column}
                                {#if header.editable}
                                    <td class="hr-cell-border {column > 4 ? 'notFixed' : 'readOnly' }">
                                        <EditableCell
                                            id="t1-{staffIndex}-{column}"
                                            on:change={(e) => updateCandidateData(e.detail.value, staff.id,  header.key)}
                                            bind:value={staff[header.key]}
                                            type={header.type}
                                            hrData="{ {staff: staff.id, key: header.key, model: 'staff', format: header.format} }"
                                            selectOptions={(header.type == "select" && reportData.options[header.selectOptionsKey]) ? reportData.options[header.selectOptionsKey] : []}
                                            customClass="hr-cell" format={header.format}></EditableCell>
                                    </td>
                                {:else}
                                    <td class="{column > 4 ? 'notFixed' : 'readOnly ' }">{staff[header.key] || ''}</td>
                                {/if}
                            {/each}
                        {:else}
                            {#each headers as header, column}
                                <td class="{column > 4 ? 'notFixed' : 'readOnly ' }">{staff[header.key] || ''}</td>
                            {/each}
                        {/if}
                    </tr>
                {/each}
            </tbody>
        </table>
    </div>
    <Pagination {currentPage} {entries}  {totalElements} on:change={(e) => currentPage = e.detail.page} />
{/if}
